<template>
    <div class="acesso-negado">
      <h1>Acesso Negado</h1>
      <p>Você não tem permissão para acessar esta página.</p>
      <router-link to="/" class="btn btn-primary">Voltar para a página inicial</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AcessoNegado'
  }
  </script>
  
  <style scoped>
  .acesso-negado {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
    background-color: #f9fafb;
  }
  
  .acesso-negado h1 {
    font-size: 2em;
    color: #007bff; /* Azul padrão do site */
    margin-bottom: 20px;
  }
  
  .acesso-negado p {
    font-size: 1.2em;
    margin-bottom: 20px;
    color: #333;
  }
  
  .acesso-negado .btn {
    padding: 10px 20px;
    font-size: 1em;
  }
  </style>